import {FrameworkHttpService} from '../framework/http/service';
import {Injectable} from '@angular/core';
import {Cast} from '../framework/cast';
import {environment} from '../../environments/environment';
import {AppUserData} from '../framework/AppUser';
import {HttpClient} from '@angular/common/http';


@Injectable()
export class AuthenticationService {

	constructor(public http: HttpClient) {
	}

	public loginViaOktaToken(thetoken: string): Promise<any> {
		return new Promise<any>((ok, err) => {

			this.http.post(environment.api.authentication.url + 'login/okta', {oktaToken: thetoken}).toPromise().then(r => {
				ok(r as AppUserData);
			}, e => {
				err(e);
			});
		});
	}
}

